import cn from 'classnames';
import React from 'react';
import { useAppContext } from 'src/context/store/app-provider';

import { ShadowView } from '../shadow-view';
import styles from './SnippetWrapper.css';
import { type SnippetWrapperProps } from './types';

export const SnippetWrapper = ({
  onClick,
  children,
  className,
  shouldInheritColor = true,
}: SnippetWrapperProps) => {
  const { isRtl, shouldInheritBg } = useAppContext();

  return (
    <ShadowView
      shouldInheritColor={shouldInheritColor}
      shouldInheritBg={shouldInheritBg}
    >
      <div dir={isRtl ? 'rtl' : 'ltr'} className={styles.SnippetWrapper}>
        <div
          className={cn(styles.SnippetWrapper__Content, className)}
          onClick={onClick}
        >
          {children}
        </div>
      </div>
    </ShadowView>
  );
};
